import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mc-prescription-index',
  templateUrl: './prescription-index.component.html',
  styleUrls: ['./prescription-index.component.scss']
})
export class PrescriptionIndexComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
